export type DropdownLinkData = {
  accessElementID: number;
  displayName: string;
  url: string;
};

export type MenuLink = { label: string; to: string };

// These access elements grant API endpoints but have no page of their own: subscriptions are
// shown on Manage School, and lessons and resources are opened from the subject sites.
const NO_PAGE_ENTRIES = ['subscriptions', 'lessons', 'resources'];

const hasNoPage = (link: DropdownLinkData) =>
  [link.url, link.displayName].some((value) =>
    NO_PAGE_ENTRIES.includes(
      (value ?? '').toLowerCase().replace(/^\/+/, '')
    )
  );

export const menuLinks = (
  links: DropdownLinkData[] | null | undefined
): MenuLink[] =>
  (links ?? [])
    .filter((link) => link.displayName !== 'Sign out' && !hasNoPage(link))
    .map((link) => ({
      label: link.displayName,
      to: '/' + link.displayName.toLowerCase().replaceAll(' ', '-'),
    }));
